import clsx from 'clsx';
import { useState } from 'react';
import { TyLink } from '../../../../../types';
import Icon from '../../../../basic/icons';
import QuickLink from '../../../../basic/quickLink';
import { buildAnalytics, DataAnalyticsLocations, DataAnalyticsTypes } from '../../../../basic/analytics';

interface MenuItemProps {
  name: string;
  linkMap: TyLink[][];
}
export default function MenuItem({ name, linkMap }: MenuItemProps): JSX.Element {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const submenuId = `mobile-menu-${name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;

  return (
    <>
      <button
        type="button"
        className="flex items-center justify-between my-4 "
        onClick={() => setIsCollapsed(prev => !prev)}
        data-testid="menuItemBtn"
        aria-expanded={!isCollapsed}
        aria-controls={submenuId}
      >
        <span className="text-sm text-inky font-medium">{name}</span>
        <Icon name="sortedArrow" className={clsx({ 'rotate-180': !isCollapsed })} aria-hidden="true" />
      </button>
      {isCollapsed || (
        <div id={submenuId} className="flex flex-col m-sm ">
          {linkMap.map((link: any, idx) => (
            <div key={idx}>
              <div className="flex flex-col space-y-md">
                <QuickLink
                  data-testid={`menu-item-quickLink-${link.label}`}
                  href={link.href}
                  className='text-sm p-2'
                  dataAnalytics={buildAnalytics(DataAnalyticsLocations.Slider, DataAnalyticsTypes.Link,
                    [DataAnalyticsLocations.Page,DataAnalyticsLocations.Header,DataAnalyticsLocations.Menu ])}
                >
                  {link.label}
                </QuickLink>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
